import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import Spinner from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';

import { getProductGridLoading } from 'redux/modules/product-grid/selectors';
import urls from 'constants/urls';
import NotFound from 'components/NotFound/NotFound';
import Breadcrumbs from 'components/Breadcrumbs';
import ProductGrid from 'components/ProductGrid';
import { getGridItemsCount } from 'redux/modules/search-and-browse/selectors';
import { log } from 'utils/error-logging';

const BREADCRUMBS = [
  {
    name: 'Groceries',
    path: urls.groceriesHome,
  },
];

const CitrusAdsBuylistPage = () => {
  const isProductGridLoading = useSelector(getProductGridLoading);
  const gridItemsCount = useSelector(getGridItemsCount);

  useEffect(() => {
    if (gridItemsCount === 0) {
      log('No products received to buylist - 404', {
        logger: 'adtech',
        section: 'buylist',
      });
    }
  }, [gridItemsCount]);

  if (isProductGridLoading) {
    return <Spinner isActive={isProductGridLoading} pageSpinner />;
  }

  if (gridItemsCount === 0) {
    return <NotFound />;
  }

  return (
    <>
      <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
      <Breadcrumbs breadcrumbs={BREADCRUMBS} />
      <ProductGrid />
    </>
  );
};

export default CitrusAdsBuylistPage;
